import React from 'react';
import { Card } from 'react-bootstrap';
import { makeNiceRpsheetLinks } from '../../utils/NiceStrings'
import { getPlayersOnline, getPlayersOnlineAdmin } from '../../components';

const WhoCard = ({ whosOnline }) => {
    let players = [...new Set(whosOnline.map(who => who.userName))];
    let oocplayers = [...new Set(whosOnline.filter(who => who.isooc === true).map(who => who.userName))];
    let idleplayers = [...new Set(whosOnline.filter(who => who.idle.length > 0).map(who => who.userName))];

    return (
        <Card className={"m-2 score-card-eom-overview"} >
            <Card.Header className={"going-on-header"}>
                <Card.Title>Who's Online?</Card.Title>
            </Card.Header>
            <Card.Body>
                <p>{makeNiceRpsheetLinks(players)} {players.length > 1 ? " are " : " is "} <strong>online</strong></p>
                <p>{makeNiceRpsheetLinks(oocplayers)} {oocplayers.length > 1 ? " are " : " is "} <strong>out of character</strong></p>
                <p>{makeNiceRpsheetLinks(idleplayers)} {idleplayers.length > 1 ? " are " : " is "} <strong>idle</strong></p>

            </Card.Body>
        </Card>
    );
}

const getWhoList = async (setWhosOnline, admin) => {
    if(admin) {
        let data = await getPlayersOnlineAdmin();
        setWhosOnline(data.users);
    
    } else {
        let data = await getPlayersOnline();
        setWhosOnline(data.users);
    }
}

export { WhoCard, getWhoList };
